import { Hammer } from "lucide-react";
import MinigameStage from "./MinigameStage";

/**
 * Pitch2Hit — placeholder tab. Marks the catalogue slot for a future Junk
 * Minigame; rendered inside MinigameStage so it shares the same consistent
 * frame as the playable games.
 */
export default function Pitch2HitComingSoon() {
  return (
    <MinigameStage>
      <div className="relative w-full h-full bg-slate-900 flex flex-col items-center
                      justify-center gap-3 text-center px-8">
        <Hammer size={42} className="text-slate-600" />
        <h3 className="text-2xl font-black text-slate-300">Pitch2Hit</h3>
        <p className="text-sm text-slate-500 max-w-sm">
          A new Junk Minigame is warming up in the bullpen. Check back soon.
        </p>
        <span className="mt-1 text-[10px] font-black uppercase tracking-widest text-amber-500/70">
          Coming Soon
        </span>
      </div>
    </MinigameStage>
  );
}
